import {Component} from '@angular/core';
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {SessionService} from "../../services/session.service";
import {Router} from "@angular/router";

/** Page that displays an AI disclaimer to the user */
@Component({
	selector: 'app-ai-disclaimer',
	imports: [
		MatButtonModule,
		MatIconModule
	],
	templateUrl: './ai-disclaimer.component.html',
	styleUrl: './ai-disclaimer.component.scss'
})
export class AiDisclaimerComponent {
	constructor(private sessionService:SessionService, private router:Router) {
	}

	agree() {
		const userId = this.sessionService.allaiUser.id;
		localStorage.setItem(`ai-disclaimer-${userId}`, 'true');
		this.router.navigate(['/']);
	}
}
